/* eslint-disable react/jsx-props-no-spreading */
import React, { SVGProps } from 'react';

interface AngleUpProps extends SVGProps<SVGSVGElement> {
  color?: string;
}

const AngleUp = ({ color = 'currentColor', ...props }: AngleUpProps) => (
  <svg
    width={14}
    viewBox="0 0 14 8"
    height={8}
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="m7 2.828-4.95 4.95L.636 6.364 7 0l6.364 6.364-1.414 1.414L7 2.828Z"
      fill={color}
    />
  </svg>
);

export default AngleUp;
